module.exports = __webpack_public_path__ + "img/priscilla-logo-letter.eec6bc13.svg";